import cm from 'helpers/commons';

const sheets = [
  {
    sheetName: 'data',
    fieldLabels: [
      '상태',
      'ID',
      '이름',
      '부서1',
      '부서2',
      '부서3',
      '부서4',
      '사원번호',
      '권한',
      '식대그룹',
      '식대정책',
      '식대(원/장)',
      '사용(원/장)',
      '사유'
    ],
    fieldValues: (item) => {
      const division =
        item.status.value === 'fail_auth'
          ? cm.notErrorTrTdDivision(item.fulldivision[0])
          : cm.trTdDivision(item.orgcode);

      const findIndex = String(item.status.cause).match(/.*\(.*:\s+([0-9]+)\s+/);
      const checkData = (findIndex && findIndex.length > 0 && findIndex[1]) || '';

      return [
        item.status.text,
        item.signid,
        item.name,
        division[0] || '',
        division[1] || '',
        division[2] || '',
        division[3] || '',
        item.comidnum,
        item.grade && item.grade.text,
        item.group.name,
        item.policy.name,
        item.task.amount,
        checkData,
        item.status.cause
      ];
    }
  }
];

export default sheets;
